import React, { useState } from 'react';
import { updateApplication } from '../API/application';
import { useSnackbarContext } from '../../contexts/Snackbar';
import messages from '../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import TextField from '@material-ui/core/TextField';
import cloneDeep from 'lodash.clonedeep';

const useStyles = makeStyles((theme) => ({
  name: { '&:hover': { cursor: 'pointer' } },
  textField: {
    maxWidth: 125,
    '& .MuiInputBase-input': {
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      fontSize: '0.875rem',
    },
  },
}));

const defaultHelpText = 'Press enter to save.';
const errorHelpText = 'Required';

export default function Name({ plan, editing, setEditing, updatePlanName }) {
  const snackbar = useSnackbarContext();

  const [name, setName] = useState(plan.displayName || plan.name);
  const [helpText, setHelpText] = useState(defaultHelpText);
  const [error, setError] = useState(false);

  const classes = useStyles({ editing });

  function startEditing() {
    if (!editing) setEditing(true);
  }

  function stopEditing() {
    setEditing(false);
    setName(plan.displayName || plan.name);
  }

  function handleNameChange(event) {
    const newName = event.target.value;
    setName(newName);
    if (!newName) {
      setHelpText(errorHelpText);
      setError(true);
    } else {
      setHelpText(defaultHelpText);
      setError(false);
    }
  }

  async function saveName() {
    if (error) return;
    if (plan.name === name) return stopEditing();
    const originalName = cloneDeep(plan.name);
    try {
      updatePlanName(plan.id, name);
      setEditing(false);
      await updateApplication({ id: plan?.id, displayName: name });
    } catch (error) {
      console.log('Error updating name', error);
      snackbar.show(messages.plans.errors.nameUpdate(name), 'error');
      updatePlanName(plan.id, originalName);
    }
  }

  return (
    <TableCell>
      {!editing && (
        <span onClick={startEditing} className={classes.name}>
          {plan.displayName || plan.name}
        </span>
      )}
      {editing && (
        <TextField
          value={name}
          autoFocus
          error={error}
          helperText={helpText}
          onChange={handleNameChange}
          onBlur={stopEditing}
          onKeyUp={(event) => {
            if (event.key === 'Enter') saveName();
          }}
          className={classes.textField}
        />
      )}
    </TableCell>
  );
}
